import { Loans } from './Loans';

export default Loans;
